import React, { useContext, useState, useEffect } from "react";
import { UserContext } from "../../contexts/user.context";
import DateContext from '../../contexts/dates.context';
import "./today.style.scss";
import {
    getCurrentAcceptedChallengesForUser,
    updateAcceptedChallenge
} from "../../utils/firebase/firebase.utils";
import Navbar from "../../components/navbar/navbar.comp";
import TodayEvent from "../../components/todayEvent/todayEvent.comp";
import Button from "../../components/button/button.comp";
import ProgressBar from "../../components/progressBar/progressBar.comp";
import { initialAcceptedChallenges } from "../../utils/initialObjects.comp";
import { formatDate } from "../../utils/dating.utils";
import { useNavigate } from "react-router-dom";

const Today = () => {

    // INPUTS
    const { userID } = useContext(UserContext);
    const navigate = useNavigate()


    // [1] GET CHALLENGES
    const [challenges, setChallenges] = useState(initialAcceptedChallenges);
    const [loadedBoolean, setLoadedBoolean] = useState(false)
    const [todayEventsBoolean, setTodayEventsBoolean] = useState(false)
    useEffect(() => {
        const timer = setTimeout(async () => {
            const checkDateInChallenges = (challenges, targetDate) => {

                for (const challenge of challenges) {

                    const events = challenge.events;

                    if (events.includes(targetDate)) {
                        return true;
                    }
                }

                return false;
            };

            const loadedChallenges = await getCurrentAcceptedChallengesForUser(userID);
            setChallenges(loadedChallenges);
            setLoadedBoolean(true)

            const todayString = formatDate(currentDate);
            setTodayString(todayString);

            setTodayEventsBoolean(checkDateInChallenges(loadedChallenges, todayString))
        }, 50);

        return () => clearTimeout(timer);

    }, []);


    // [2] GET TODAY EVENTS
    function calculateEventsForToday(challenges, today) {
        let doneEventsCount = 0;
        let totalEventsCount = 0;

        challenges.forEach(challenge => {
            // Loop through the 'events' array in chunks of 5 (since each event has 5 values)
            for (let i = 3; i < challenge.events.length; i += 5) {
                const eventDate = challenge.events[i];
                const eventDone = challenge.events[i + 1];

                // Ensure the eventDate is in the same format as 'today'
                if (new Date(eventDate).toISOString().split('T')[0] === today) {
                    // Increment total events for today's date
                    totalEventsCount++;

                    // Increment done events if the boolean is true
                    if (eventDone === true) {
                        doneEventsCount++;
                    }
                }
            }
        });

        return { doneEventsCount, totalEventsCount };
    }
    const [doneEvents, setDoneEvents] = useState()
    const [totalEvents, setTotalEvents] = useState()
    const [percentageComplete, setPercentageComplete] = useState(0)
    useEffect(() => {
        const todayString = formatDate(currentDate);

        const { doneEventsCount, totalEventsCount } = calculateEventsForToday(challenges, todayString);
        setDoneEvents(doneEventsCount);
        setTotalEvents(totalEventsCount);

        const ratio = (doneEventsCount / totalEventsCount) * 100;
        setPercentageComplete(ratio)

    }, [challenges]);


    //[2] REFRESH
    const handleRefresh = async () => {
        const loadedChallenges = await getCurrentAcceptedChallengesForUser(userID);
        setChallenges(loadedChallenges);
    }


    // [2] DATING
    const { currentDate } = useContext(DateContext)
    const [todayString, setTodayString] = useState("2024-08-30")
    const [dateObject, setDateObject] = useState({
        dayOfMonth: currentDate.dayOfMonth,
        dayOfWeek: currentDate.dayOfWeek,
        month: currentDate.month,
        year: currentDate.year
    })


    //[2] DONE POP UP
    const [savePopUp, setSavePopUp] = useState(false)
    const [saving, setSaving] = useState(false)
    const [saved, setSaved] = useState(false)
    const handleClosePopUp = () => {
        setSavePopUp(false)
        setSaving(false)
        setSaved(false)
    }


    //[2] SE MORE POP UP
    const [seeMorePopUp, setSeeMorePopUp] = useState(false)
    const handleSeeMore = () => {
        setSavePopUp(false)
        setSeeMorePopUp(true)
    }
    const handleCloseSeeMore = () => {
        setSeeMorePopUp(false)
    }
    const handleVideoClick = () => {
        if (challenges[doneChallengeIndex].videoURL) {
            window.open(challenges[doneChallengeIndex].videoURL, '_blank'); // Open video URL in a new tab
        } else {
            console.log('No video URL available');
        }
    }
    const handleGoToChallenge = () => {
        if (challenges[doneChallengeIndex]) {
            navigate(`/challenge/${challenges[doneChallengeIndex].challengeID}`);
        }
    }


    //[3] POST: MARKING DONE (firebase)
    const [doneChallengeIndex, setDoneChallengeIndex] = useState(false)
    const [doneEventBooleanIndex, setDoneEventBooleanIndex] = useState(false)
    const handleClick = (challengeIndex, eventNumber) => {
        const booleanIndex = (eventNumber * 5) - 1;
        // console.log(challengeIndex, eventNumber, booleanIndex)

        setDoneChallengeIndex(challengeIndex)
        setDoneEventBooleanIndex(booleanIndex)

        setSavePopUp(true)
    }
    const handleSaveToFireDone = async () => {
        setSaving(true);

        // Access the specific challenge using doneChallengeIndex
        const specificChallenge = challenges[doneChallengeIndex];

        // Directly access the boolean value using doneEventBooleanIndex
        const booleanIndex = doneEventBooleanIndex;
        const currentValue = specificChallenge.events[booleanIndex];

        // Toggle the value
        specificChallenge.events[booleanIndex] = true;

        // Prepare the updated data
        const updatedData = {
            events: specificChallenge.events, // Updated events array
            // You can add more fields here if needed
        };

        // Update the accepted challenge in Firestore
        await updateAcceptedChallenge(specificChallenge.acceptedID, updatedData);

        // Update state to trigger re-render
        setChallenges(prevChallenges => {
            const updatedChallenges = [...prevChallenges];
            updatedChallenges[doneChallengeIndex] = { ...specificChallenge };

            setSavePopUp(false)
            setSaving(false)
            setSaved(false)

            return updatedChallenges;
        });

        setDoneChallengeIndex(false)
        setDoneEventBooleanIndex(false)
    };
    const handleSaveToFireNotDone = async () => {
        setSaving(true);

        // Access the specific challenge using doneChallengeIndex
        const specificChallenge = challenges[doneChallengeIndex];

        // Directly access the boolean value using doneEventBooleanIndex
        const booleanIndex = doneEventBooleanIndex;
        const currentValue = specificChallenge.events[booleanIndex];

        // Toggle the value
        specificChallenge.events[booleanIndex] = false;

        // Prepare the updated data
        const updatedData = {
            events: specificChallenge.events, // Updated events array
            // You can add more fields here if needed
        };

        // Update the accepted challenge in Firestore
        await updateAcceptedChallenge(specificChallenge.acceptedID, updatedData);

        // Update state to trigger re-render
        setChallenges(prevChallenges => {
            const updatedChallenges = [...prevChallenges];
            updatedChallenges[doneChallengeIndex] = { ...specificChallenge };

            setSavePopUp(false)
            setSaving(false)
            setSaved(false)

            return updatedChallenges;
        });

        setDoneChallengeIndex(false)
        setDoneEventBooleanIndex(false)
    };


    return (
        <div>
            <Navbar option={1} />

            {/* Date & Progress Bar */}
            <div className="section today tight">
                {/* <h2>{currentDate.dayOfWeek}, {currentDate.dayOfMonth} {currentDate.month}</h2> */}
                <h2 style={{ color: 'var(--fontlightblack1)' }}>{dateObject.dayOfWeek}, {dateObject.dayOfMonth} {dateObject.month}</h2>
                <ProgressBar percentageCompletion={percentageComplete} />
                <div style={{ display: 'flex', justifyContent: "flex-end" }}>
                    {doneEvents !== totalEvents ? (
                        <p style={{ fontSize: 'small', margin: 0, fontWeight: 'bold', color: 'var(--fontdarkgrey)' }}>
                            {doneEvents} / {totalEvents}
                        </p>
                    ) : (
                        <p style={{ fontSize: 'small', margin: 0, fontWeight: 'bold', color: 'var(--fontdarkgrey)' }}>
                            All done!
                        </p>
                    )}
                </div>
            </div>

            {/* Loading Circle */}
            {!loadedBoolean && (
                <div className="loading-circle"></div>
            )}

            {/* Today Events */}
            {loadedBoolean && (
                <div className="section tight">
                    {challenges.map((challengeObject, challengeIndex) => {

                        return (
                            <div key={challengeIndex}>
                                {challengeObject.events.map((row, index) => {

                                    const today = todayString;
                                    const eventsArray = challengeObject.events;

                                    if (row === today) {

                                        const eventNumber = eventsArray[index - 3];
                                        const boolean = eventsArray[index + 1];

                                        const uniqueId = challengeObject.acceptedID;

                                        return (
                                            <TodayEvent
                                                key={eventNumber}
                                                eventTime={challengeObject.eventTime}
                                                eventTitle={challengeObject.eventTitle}
                                                uniqueId={uniqueId}
                                                eventNumber={eventNumber}
                                                totalEvents={challengeObject.eventsTotal}
                                                challengeTitle={challengeObject.title}
                                                index={index}
                                                boolean={boolean}
                                                onHandleClick={handleClick}
                                                challengeIndex={challengeIndex}
                                            />
                                        );
                                    }
                                    return null;
                                })
                                }
                            </div>
                        )
                    })}
                    {challenges.length === 0 && (
                        <Button text={'Refresh'} option={'button-linked-text'} onClick={handleRefresh} />
                    )}
                </div>
            )}

            {/* No Events */}
            {loadedBoolean && !todayEventsBoolean && (
                <p>No events scheduled for today</p>
            )}

            {/* Pop Up Save Changes */}
            {savePopUp && (
                <div className="today-pop-up-container">
                    <div className="today-pop-up">
                        <div className="today-pop-up-header">
                            <div className="title">
                                <div />
                                <div
                                    className="close pointer"
                                    style={{
                                        backgroundImage: `url(${'https://logowik.com/content/uploads/images/close1437.jpg'})`,
                                        backgroundSize: 'cover',
                                        backgroundPosition: 'center',
                                        backgroundRepeat: 'no-repeat'
                                    }}
                                    onClick={handleClosePopUp}
                                />
                            </div>
                        </div>
                        {saving ? (
                            <div className="today-pop-up-scroll-view ">
                                <p style={{ width: '100%', textAlign: 'center' }}>Saving...</p>
                                <div
                                    style={{ display: 'flex', width: '100%', gap: '12px', marginTop: '12px', marginBottom: '12px', justifyContent: "center" }}
                                >
                                    <div className="this-week-loading-circle"></div>
                                </div>
                            </div>
                        ) : (
                            <div className="today-pop-up-scroll-view">
                                <div
                                    style={{
                                        backgroundImage: `url(${challenges[doneChallengeIndex].imageURL})`,
                                        backgroundSize: 'cover',
                                        backgroundPosition: 'center',
                                        backgroundRepeat: 'no-repeat',
                                        height: '200px',
                                        width: '200px',
                                        borderRadius: '20px'
                                    }}
                                />
                                <p style={{ marginBottom: '0', color: 'var(--fontlightblack)', fontWeight: '500' }}>{challenges[doneChallengeIndex].event}</p>
                                <div
                                    style={{ display: 'flex', width: '100%', gap: '12px', marginTop: '12px', marginBottom: '12px', justifyContent: "center" }}
                                    className="pop-up-buttons"
                                >
                                    <Button text={'Not Done'} option={'button-linked-text'} onClick={handleSaveToFireNotDone} />
                                    <Button text={'Done'} option={'green'} onClick={handleSaveToFireDone} />
                                </div>
                                <p
                                    style={{ fontSize: 'small', cursor: "pointer", margin: '0', fontWeight: '500', color: 'var(--fontlightblack1)' }}
                                    onClick={handleSeeMore}
                                >
                                    see more
                                </p>
                            </div>
                        )}
                    </div>
                </div>
            )}

            {/* Pop Up: See More */}
            {seeMorePopUp && (
                <div className="see-more-pop-up-container">
                    <div className="see-more-pop-up">
                        <div className="see-more-pop-up-header">
                            <div className="title">
                                <div />
                                <div
                                    className="close pointer"
                                    style={{
                                        backgroundImage: `url(${'https://logowik.com/content/uploads/images/close1437.jpg'})`,
                                        backgroundSize: 'cover',
                                        backgroundPosition: 'center',
                                        backgroundRepeat: 'no-repeat'
                                    }}
                                    onClick={handleCloseSeeMore}
                                />
                            </div>
                        </div>
                        <div className="see-more-pop-up-scroll-view">
                            <div
                                style={{
                                    backgroundImage: `url(${challenges[doneChallengeIndex].imageURL})`,
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'center',
                                    backgroundRepeat: 'no-repeat',
                                    height: '200px',
                                    width: '200px',
                                    borderRadius: '20px'
                                }}
                            />
                            {challenges[doneChallengeIndex].video && (
                                <p className="link" onClick={handleVideoClick}>video</p>
                            )}
                            <p
                                style={{ fontSize: 'small', cursor: "pointer", fontWeight: '500', color: 'var(--fontlightblack1)' }}
                                onClick={handleGoToChallenge}>
                                Go to challenge
                            </p>
                            <div className="text">
                                <div className='description-container'>
                                    {challenges[doneChallengeIndex].about.split('\n\n').map((paragraph, index) => (
                                        <p key={index} style={{ marginBottom: '12px', textAlign: 'left' }}>{paragraph}</p>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <div className="footer-margin">
            </div>
        </div>
    );
};

export default Today;